import React from 'react';
import { connect } from 'react-redux';
import { useIntl } from 'react-intl';
import { Form, Input } from 'semantic-ui-react';
import { clientError, firstError, validationClasses } from '@/utils/errors';
import { states } from '@/constants/lifecycle';
import fields, { globalFieldLengths } from '@/constants/fields';
import MarkdownEditor from '@/components/text-editors/MarkdownEditor';
import FormValidationError from '@/components/errors/FormValidationError';
import Dialog from '@/components/dialogs/Dialog';
import { hideRenameQuery, updateActiveQueryProperties } from '../actions';

const RenameQueryDialog = ({
  description,
  hide,
  name,
  saveStatus,
  saveErrors,
  theme,
  updateProperties,
}) => {
  const intl = useIntl();
  const setErrors = (newErrors) => (updateProperties({ saveErrors: newErrors }));

  const nameChange = (e) => {
    updateProperties({ name: e.target.value });
  };

  const descriptionChange = (value) => {
    updateProperties({ description: value });
  };

  const validateForm = () => {
    const validationErrors = [];

    if (description && description.length > globalFieldLengths.description) {
      validationErrors.push(
        clientError(
          { entity: 'query' },
          intl.formatMessage({ id: 'save.cohort.validation.query.description.title' }),
          intl.formatMessage({ id: 'validation.max.length' }, { maximum: globalFieldLengths.description }),
          [fields.DESCRIPTION],
        ),
      );
    }

    return validationErrors;
  };

  const checkForErrors = () => {
    const validationErrors = validateForm();
    setErrors(validationErrors);

    return validationErrors;
  };

  const submitForm = () => {
    const validationErrors = checkForErrors();

    if (validationErrors.length === 0) {
      hide(false);
    }
  };

  const nameError = saveErrors ? saveErrors.find((e) => (e.fields.includes(fields.NAME))) : null;
  const descriptionError = saveErrors ? saveErrors.find((e) => (e.fields.includes(fields.DESCRIPTION))) : null;

  return (
    <Dialog
      className="aridhia-save-cohort-dialog"
      icon="edit"
      minimumDataEntryMet={name}
      onClose={() => hide(true)}
      onSave={submitForm}
      saveMessageId="actions.modify"
      theme={theme}
      title={intl.formatMessage({ id: 'save.cohort.query.update.title' })}
    >
      <Form autoComplete="off" onSubmit={submitForm} error={firstError(saveErrors) !== null}>
        <FormValidationError
          error={nameError}
          htmlFor="cohort_name"
          labelId="save.cohort.query.name"
        >
          <Input
            id="cohort_name"
            autoFocus
            disabled={saveStatus === states.PENDING}
            type="custom"
            size="large"
            placeholder={intl.formatMessage({ id: 'save.cohort.query.name.placeholder' })}
            value={name}
            maxLength={globalFieldLengths.name}
            onChange={nameChange}
            className={validationClasses(nameError)}
          />
        </FormValidationError>
        <FormValidationError
          error={descriptionError}
          htmlFor="cohort_query_description"
          labelId="save.cohort.query.description"
        >
          <MarkdownEditor
            id="cohort_query_description"
            disabled={saveStatus === states.PENDING}
            value={description}
            onChange={descriptionChange}
            maxEditorHeight={80}
            minPreviewHeight={94}
            className={validationClasses(descriptionError)}
          />
        </FormValidationError>
      </Form>
    </Dialog>
  );
};

const mapStateToProps = ({
  cohorts: {
    activeQuery: {
      name, description, saveErrors, saveStatus,
    },
  },
}) => ({
  description,
  name,
  saveErrors,
  saveStatus,
});

const mapDispatchToProps = {
  hide: hideRenameQuery,
  updateProperties: updateActiveQueryProperties,
};

export default connect(mapStateToProps, mapDispatchToProps)(RenameQueryDialog);
